import React, { useEffect } from "react";
import { connect } from "react-redux";

import { Actions as ASSETACTIONS } from "../../../store/actions/assetActions";
import { useParams } from "react-router-dom";
import AssignmentRow from "./AssignmentRow";

const AssetEmployee = ({
    history,
    getAssignmentHistory
}) => {
    const { id } = useParams()

    useEffect(() => {
        if (id) getAssignmentHistory(id)
    }, [id])

    return (
        <div className="table-responsive" style={{ overflow: "auto" }}>

            {/* If it is already loaded this */}
            <div className="dataTables_wrapper no-footer">
                <table
                    className="js-table-sections table table-hover"
                >
                    <thead style={{ display: 'table-header-group' }}>
                        <tr>
                            <th width="5%"></th>
                            <th>NAME</th>
                            <th>FROM</th>
                            <th>TO</th>
                            {/* <th>RETURNED AT</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {history?.map((assignment) => {
                            return <AssignmentRow key={assignment.id} assignment={assignment} />
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {

    return {
        history: state.asset?.item?.history || []
    };
};

const mapDispatchToProps = (dispatch) => ({
    getAssignmentHistory: (id) => dispatch(ASSETACTIONS.getAssignmentHistory(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssetEmployee);
